import React,{useState} from "react";
import Logo from './logo';
import { Link } from "react-router-dom";
import {SendIcon} from "../custom-icons/SendIcon";
import {APP_URL,API_ENDPOINT, toast_anim , pdfdoconly} from '../components/config/Common'
import {Links} from '../routes/PathLink'
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import axios from 'axios';  
import { LazyLoadImage,LazyLoadComponent } from 'react-lazy-load-image-component';
import { FloatingWhatsApp } from 'react-floating-whatsapp'
import { useSiteSettings } from '../site-settings/site-settings';

import {
    Control,
    FieldErrors,
    useForm,
    useFormState,
    useWatch,
    Controller
 } from 'react-hook-form';

import { AiFillTwitterCircle, AiFillInstagram, AiFillFacebook, AiFillLinkedin , AiFillYoutube } from 'react-icons/ai';

const newletterSchema = Yup.object().shape({
    email: Yup.string()
        .required('You must need to provide email address.')
        .email('Invalid email.'),       
});

let defaultValues = {  
    email:'',
};



const Footer = () => {
    const [loading, setLoading] = useState(false);
     const { sitelogo } = useSiteSettings();
     const [user_type, setUser_type] = useState(localStorage.getItem('user_type'))
    const logos = [
        {logo:'/img/make-in-india.png'},
        {logo:'/img/digitalIndia-logo.png'},
        {logo:'/img/Azadi_Ka_Amrit_Mahotsav.png'},
        {logo:'/img/vision-india.jpg'},
        {logo:'/img/aatmanirbhar-bharat-logo.png'},
    ]


    const { register, handleSubmit , control, reset, setValue, setError, formState: { errors },} = useForm({
        defaultValues: defaultValues,
        resolver: yupResolver(newletterSchema),
    });


    const onSubmitNews = (values) => {
        console.log('value', values)
        setLoading(true)        

        let input = values;
      input = {...input,
      }

      setLoading(true)
      axios.post(`${API_ENDPOINT}/add_newletter_subscription`,input,{
         headers: {
            'Content-Type': 'multipart/form-data'
         }
      }).then( (result)=> {
         console.log('data=====',result.data)
         setLoading(false)
         console.log('data=====',result)
            if(result.data.status === 1){
                //setSubmitting(false)
                //localStorage.setItem('user_name',result.data.name);
                toast_anim(result.data.message)
            }
      })

        
    }

    return (
        <div className="">
            {/* Top */}
            <LazyLoadComponent>
            <div className="flex items-center justify-center flex-wrap w-full gap-6 bg-white py-5 px-5 md:px-5">
                {
                logos.map((val,key) => (
                <div key={`logo-${key}`} className="flex items-center justify-center w-[40%] lg:w-56 bg-light rounded">
                    <LazyLoadImage src={`${APP_URL}${val.logo}`} className="h-28 object-contain" alt="" />
                </div>
                ))
                }
            </div>
             </LazyLoadComponent>

            <div className="bg-gray-100 py-10 px-5 md:px-5">
                <h3 className="text-center text-2xl text-body mb-10">We are currently working and dealing with Indian Dealers and Refurbishers only!</h3>
                {/*<h3 className="text-center text-4xl text-body mt-4 mb-3">Delivery Partner</h3>
                <div className="flex justify-center flex-col items-center mt-2 text-body">
                <img src={`${APP_URL}/img/dtdc.png`} className="h-28 object-contain" alt="delivery partner at food" /></div>
                */}
                <div class="flex flex-col md:flex-row items-center justify-around">
                    <div><h3 class="text-center text-4xl text-accent mt-4 mb-3 uppercase">Our 
                        <span class="bg-accent text-white px-2">Delivery</span> Partner</h3>
                        <div class="flex justify-center flex-col items-center mt-2 text-body">
                        <img src={`${APP_URL}/img/dtdc.png`} class="h-28 object-contain" alt="DTDC delivery partner" /></div>
                        </div>
                        <div><h3 class="text-center text-4xl text-accent mt-4 mb-3 uppercase">Our <span class="bg-accent text-white px-2">Finance</span> Partner</h3>
                        <div class="flex justify-center items-center mt-2 text-body gap-3">
                        <img src={`${APP_URL}/img/hdfc-bank.png`} class="h-28 object-contain" alt="HDFC Finance partner" />
                        <img src={`${APP_URL}/img/axis-bank.png`} class="h-28 object-contain" alt="AXIS Finance partner" />
                        </div>
                        </div>
                        </div>


            </div>
            
            <div className="bg-accent-300 border-t-2 border-accent  gap-6 py-10 grid w-full grid-cols-[repeat(auto-fill,minmax(260px,1fr))] gap-6 pt-16 md:grid-cols-3 xl:grid-cols-[repeat(auto-fit,minmax(220px,1fr))] xl:gap-8 2xl:gap-2 2xl:grid-cols-4 px-5 md:px-10 lg:px-[50px] xl:px-16 justify-center m-auto">
                <div className="flex flex-col">
                    <div className="mb-[2px] flex h-16 items-start">
                        <Logo />
                    </div>
                    <address className="mb-7 text-sm not-italic text-heading dark:text-zinc-300 capitalize mt-5">
                    Block no.5 Ashwamegh apt <br /> lendra park ramdaspeth, <br />Nagpur-440012.
                    </address>
                    <span className="mb-1 text-sm text-heading dark:text-zinc-300">
                    <a href="mailto:support@ctmrihub.com">support@ctmrihub.com</a>
                    </span>
                    <span className="text-sm text-heading dark:text-zinc-300">
                    <a href={`tel:+917387869666`}>+917387869666</a><br/><a href={`tel:+918329720772`}>+918329720772</a>
                    </span>
                </div>

                <div className="flex flex-col">
                <h3 className="mt-3 mb-7 text-xl font-semibold text-heading text-accent dark:text-zinc-300">
                    Services
                    </h3>
                    <ul className="space-y-3">
                        <li>
                            <Link to={Links.CONTACT} className="text-sm text-heading transition-colors hover:text-orange-500 dark:text-zinc-300 dark:hover:text-orange-500">SUPPORT CENTER</Link>
                        </li>
                        <li>
                            <Link to={Links.HELP} className="text-sm text-heading transition-colors hover:text-orange-500 dark:text-zinc-300 dark:hover:text-orange-500">EQUIPMENT SUPPORT</Link>
                        </li>
                        <li>
                            <Link to={Links.FREE_CONSULTATION} className="text-sm text-heading transition-colors hover:text-orange-500 dark:text-zinc-300 dark:hover:text-orange-500">POST YOUR REQUIREMENT</Link>
                        </li>
                        <li>
                            <Link to={Links.PARTSREPAIR} className="text-sm text-heading transition-colors hover:text-orange-500 dark:text-zinc-300 dark:hover:text-orange-500">SPARE PARTS REPAIR SERVICE</Link>
                        </li>
                         <li>
                            <Link to={Links.AERBLICENSING} className="text-sm text-heading transition-colors hover:text-orange-500 dark:text-zinc-300 dark:hover:text-orange-500">AERB LICENSING SERVICE</Link>
                        </li>
                        
                        <li>
                            <Link to={Links.CARRIER} className="text-sm text-heading transition-colors hover:text-orange-500 dark:text-zinc-300 dark:hover:text-orange-500">Careers</Link>
                        </li>
                         <li>
                            <Link to={Links.HIRECHAINPULLI} className="text-sm text-heading transition-colors hover:text-orange-500 dark:text-zinc-300 dark:hover:text-orange-500">Hire Chain Pulli Labourers</Link>
                        </li>
                         <li>
                            <Link to={Links.DEALER_SUBSCRIPTION_PLANS} className="text-sm text-heading transition-colors hover:text-orange-500 dark:text-zinc-300 dark:hover:text-orange-500">Dealer Subscription Plans</Link>
                        </li>
                         <li>
                            <Link to={Links.REPORTFRAUD} className="text-sm text-heading transition-colors hover:text-orange-500 dark:text-zinc-300 dark:hover:text-orange-500">REPORT A FRAUD</Link>
                        </li>
                        <li>
                            <Link to={Links.DIET_NUTRITION} className="text-sm text-heading transition-colors hover:text-orange-500 dark:text-zinc-300 dark:hover:text-orange-500">CTMRIHUB Diet & Nutrition</Link>
                        </li>
                    </ul>
                </div>
                <div className="flex flex-col">
                <h3 className="mt-3 mb-7 text-xl font-semibold text-heading text-accent dark:text-zinc-300">
                    Browse
                    </h3>
                    <ul className="space-y-3">
                        <li>
                            <Link to={Links.ABOUT} className="text-sm text-heading transition-colors hover:text-orange-500 dark:text-zinc-300 dark:hover:text-orange-500">About</Link>
                        </li>
                        
                        
                        {/*<li>
                            <Link to={Links.UPCOMING_PRODUCTS} className="text-sm text-heading transition-colors hover:text-orange-500 dark:text-zinc-300 dark:hover:text-orange-500">Upcoming Products</Link>
                        </li>
                          <li>
                            <Link to={Links.FEATURED_PRODUCTS} className="text-sm text-heading transition-colors hover:text-orange-500 dark:text-zinc-300 dark:hover:text-orange-500">Featured Products</Link>
                        </li>*/}
                          <li>
                            <Link to={Links.POPULAR_PRODUCTS} className="text-sm text-heading transition-colors hover:text-orange-500 dark:text-zinc-300 dark:hover:text-orange-500">Popular Products</Link>
                        </li>
                        <li>
                            <Link to={Links.TESTIMONIALS} className="text-sm text-heading transition-colors hover:text-orange-500 dark:text-zinc-300 dark:hover:text-orange-500">Testimonials</Link>
                        </li>
                        <li>
                            <Link to={Links.WHYCTMRIHUB} className="text-sm text-heading transition-colors hover:text-orange-500 dark:text-zinc-300 dark:hover:text-orange-500">Why CTMRI HUB?</Link>
                        </li>
                        <li>
                            <Link to={Links.SHIPPINGPOLICY} className="text-sm text-heading transition-colors hover:text-orange-500 dark:text-zinc-300 dark:hover:text-orange-500">Shipping Policy</Link>
                        </li>
                        
                         <li>
                            <Link to={Links.BLOG} target="_blank" className="text-sm text-heading transition-colors hover:text-orange-500 dark:text-zinc-300 dark:hover:text-orange-500">Blog</Link>
                        </li> 
                        
                    </ul>
                </div>

                <div className="flex flex-col">
                    <h3 className="text-accent mt-3 mb-7 text-xl font-semibold text-heading dark:text-zinc-300">
                    Subscribe Now
                    </h3>
                    <p className="mb-7 text-sm text-heading dark:text-zinc-300">Subscribe your email for newsletter and featured news based on your interest</p>
                     <form onSubmit={handleSubmit(onSubmitNews)}>
                    <div className="flex flex-col">
                        <div className="relative w-full rounded border border-gray-200 bg-gray-50 ltr:pr-11 rtl:pl-11">
                            <input
                                type="email"
                                {...register('email')}
                                id="email_subscribe"                                
                                placeholder={'Write your email here'}
                                className="h-14 w-full border-0 bg-transparent text-sm text-body outline-none focus:outline-none ltr:pl-5 rtl:pr-5"
                            />
                            <button className="absolute top-1/2 -mt-2 ltr:right-3 rtl:left-3"><SendIcon className="text-gray-500 transition-colors hover:text-accent" /></button>
                        </div>
                        <div className="text-red-500 text-sm">{errors.email?.message}</div>
                    </div>
                    </form>
                     
                    <h3 className="mt-5 mb-3 text-xl font-semibold text-heading dark:text-zinc-300">
                    Follow us on
                    </h3>
                    <div className="flex">
                        <a href="https://www.facebook.com/profile.php?id=100094913228352" rel="noreferrer" target="_blank" className="mr-2 text-3xl text-accent hover:text-[#1877f2]"><AiFillFacebook /></a>
                        <a href="https://twitter.com/ctmrihub123" rel="noreferrer" target="_blank" className="mr-2 text-3xl text-accent hover:text-[#1da1f2]"><AiFillTwitterCircle /></a>
                        <a href="https://www.instagram.com/ctmrihub/" rel="noreferrer" target="_blank" className="mr-2 text-3xl text-accent hover:text-[#c13584]"><AiFillInstagram /></a>
                        <a href="https://in.linkedin.com/company/ctmrihub-com" rel="noreferrer" target="_blank" className="mr-2 text-3xl text-accent hover:text-[#0A66C2]"><AiFillLinkedin /></a>
                        <a href="https://www.youtube.com/@Ctmrihub-India" rel="noreferrer" target="_blank" className="mr-2 text-3xl text-accent hover:text-[#0A66C2]"><AiFillYoutube /></a>
                    </div>
                    <div class="app-download mt-5"><div class="app-pos"><div class="text-md">DOWNLOAD OUR APP</div><div><a href="https://play.google.com/store/apps/details?id=com.ctmri" target="_blank"><img src="/play-store-download.webp" /></a></div></div></div>
                    <FloatingWhatsApp
                        phoneNumber="8421008839"
                        accountName="CTMRIHUB"
                        allowEsc
                        allowClickAway
                        notification
                        notificationSound
                        avatar={`${process.env.REACT_APP_IMG_URL+sitelogo}`}
                      />
                </div>
            </div>
            <div className="flex w-full flex-col gap-3 items-center lg:flex-row lg:justify-between px-5 md:px-10 py-5 bg-accent text-white mb-10 md:mb-0">
                <div className="order-2 text-sm  text-white text-heading lg:order-1 dark:text-zinc-300 flex flex-col lg:flex-row items-center gap-2">
                <div>&copy; Copyright {new Date().getFullYear()}{' '}
                <Link
                    className="font-bold text-heading transition-colors text-white hover:text-white dark:text-zinc-100 dark:hover:text-accent"
                    to='/'
                >
                  ctmrihub.com
                </Link>{' '}
                All rights reserved
                </div>
                <div>
                    <Link to={Links.PRIVACY} className="text-sm text-heading transition-colors hover:text-white dark:text-zinc-300 dark:hover:text-orange-500">Privacy Policy</Link>
                    <span className="mx-2">|</span>
                    <Link to={Links.TERMS} className="text-sm text-heading transition-colors hover:text-white dark:text-zinc-300 dark:hover:text-orange-500">Terms and conditions</Link>
                </div>
                </div>
                    
                <div class="order-2 text-sm lg:order-1 dark:text-zinc-300">Designed and Developed by SISNOLABS</div>
            </div>
        </div>
    )

}

export default Footer;
